import { makeRequestGet } from "../../../../../Services/API";

export function getAtributosArtigo(itmref, lang) {
  return makeRequestGet(`/backend/catalogo/Atributos/${lang}?itmref=${itmref}`);
}
